import ApiService from '../common/api.service'
import {
  GETNOTESLISTBYORDERID, POSTNOTE, GETFEEDBACKLISTBYORDERID, DELETEFEEDBACKBYID, ADDFEEDBACK, GETERRORTYPELIST
} from './actions.type'
import { SET_NOTELIST, SET_ERROR } from './mutations.type'

const state = {
  errors: null,
  notesList: [],
  errorMessage: null,
  errorType: null
}

const getters = {
  notesList () {
    return state.notesList
  },
  error (state) {
    return state.error
  },
  errorMessage (state) {
    return state.errorMessage
  },
  errorType (state) {
    return state.errorType
  }
}

const actions = {
  [GETNOTESLISTBYORDERID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('order_notes', `?order__id=${payload.order__id}&type=${payload.type}&page_size=100000`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_NOTELIST, data.results)
        return data.results
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [POSTNOTE] (context, payload) {
    ApiService.setHeader()
    return ApiService.post(`order_notes/`, payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [ADDFEEDBACK] (context, payload) {
    ApiService.setHeader()
    return ApiService.post(`feedback/`, payload)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [DELETEFEEDBACKBYID] (context, payload) {
    ApiService.setHeader()
    return ApiService.delete(`feedback/${payload.id}/`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [GETFEEDBACKLISTBYORDERID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get('feedback', `?order__id=${payload.order__id}`)
      .then(({ data }) => {
        console.log(data)
        return data.results
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [GETERRORTYPELIST] (context) {
    ApiService.setHeader()
    return ApiService.get('error_types')
      .then(({ data }) => {
        console.log(data)
        return data.results
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error.data
    state.errorMessage = error.data
    state.errorType = error.status + ': ' + error.statusText
  },
  [SET_NOTELIST] (state, notesList) {
    state.notesList = notesList
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
